import React, { Component } from "react";
import { Tabs, Modal, Tooltip, Badge } from "antd";
import { stringify } from "qs";
import { connect } from "dva";
import { router } from "umi";
import moment from "moment";
import styles from "./index.less";
import Container from "../../../../../components/Container";
import ListPage from "../../../../../components/ListPage";
import OperateDropdown from "../../../../../components/OperateDropdown";

const { info, confirm, warning } = Modal;
const { ListTable, ListCreate } = ListPage;
const { TabPane } = Tabs;
const statusMap = {
  "1": "default",
  "2": "processing",
  "3": "default"
};

const statusNameMap = {
  "1": "未开始",
  "2": "进行中",
  "3": "已结束"
};

@connect(({ projectList }) => ({
  spinProps: projectList.spinProps,
  projectList: projectList.projectList,
  pageInfo: projectList.pageInfo
}))
class List extends Component {
  constructor(props) {
    super(props);

    const columns = [
      {
        title: "项目名称",
        dataIndex: "projectName",
        width: 330,
        fixed: "left",
        render: projectName => (
          <Tooltip placement="top" title={projectName}>
            <span>
              {projectName?.length <= 20
                ? projectName
                : `${projectName?.substring(0, 20)}...`}
            </span>
          </Tooltip>
        )
      },
      {
        title: "状态",
        dataIndex: "status",
        render: status => {
          const statusCls = statusMap[status];
          const statusName = statusNameMap[status];
          return <Badge status={statusCls} text={statusName} />;
        }
      },
      {
        title: "负责人",
        dataIndex: "principalList",
        render: principalList => {
          if (principalList.length) {
            return (
              <Tooltip
                placement="top"
                title={principalList?.map(item => (
                  <span>{item.userName} </span>
                ))}
              >
                <span>
                  {principalList?.length > 1
                    ? `${principalList[0].userName}...`
                    : principalList[0].userName}
                </span>
              </Tooltip>
            );
          }
          return (
            <Tooltip placement="top" title="-">
              <span>-</span>
            </Tooltip>
          );
        }
      },
      {
        title: "开始日期",
        dataIndex: "startTime",
        render: startTime => moment(startTime).format("YYYY.MM.DD")
      },
      {
        title: "结束日期",
        dataIndex: "endTime",
        render: endTime => moment(endTime).format("YYYY.MM.DD")
      },
      {
        title: "操作",
        width: 160,
        fixed: "right",
        render: record => {
          const { allowEdit } = record;
          const data = allowEdit
            ? [
                {
                  text: this.renderEditBtn(record)
                },
                {
                  text: this.renderDelBtn(record)
                }
              ]
            : [
                {
                  text: this.renderDelBtn(record)
                }
              ];
          return <OperateDropdown data={data} />;
        }
      }
    ];

    this.state = {
      columns,
      currentTabKey:'1',
      tabData: [
        {
          tabName: "督政",
          tabKey: "1"
        },
        {
          tabName: "督学",
          tabKey: "2"
        },
        {
          tabName: "评估监测",
          tabKey: "3"
        }
      ]
    };
  }

  componentDidMount() {
    this.getList({ page: 1, pageSize: 10 });
  }

  handleEdit = ({ record: { projectId } }) => {
    // 编辑
    router.push(
      `/supervision/norm/project/edit?${stringify({
        currentProjectId: projectId
      })}`
    );
  };

  handleJump = (id, record) => {
    const { projectId } = record;
    // 查看
    router.push(
      `/supervision/norm/project/overview?${stringify({
        currentProjectId: projectId
      })}`
    );
  };

  handleDelete = ({ record: { projectId, status } }) => {
    // 删除
    const { dispatch } = this.props;
    if (statusNameMap[status] === "进行中") {
      warning({
        title: "提示",
        content: "项目已开始，不能删除",
        okText: "确认"
      });
    } else {
      confirm({
        title: "删除项目",
        content: "确定删除该项目吗？",
        okText: "确认",
        cancelText: "取消",
        onOk: () => {
          dispatch({
            type: "project/fetchDeleteProject",
            payload: {
              projectId: Number(projectId)
            },
            callback: () => this.getList({ page: 1, pageSize: 10 })
          });
        }
        // onCancel: this.handleDeleteCancel,
      });
    }
  };

  handleAddProject = () => {
    router.push(`/supervision/norm/project/create`);
  };

  // 分页改变
  handlePaginationChange = (page, pageSize) => {
    const pageInfo = { page, pageSize };
    this.getList(pageInfo);
  };

  getList = pageInfo => {
    const { currentTabKey } = this.state;
    const { dispatch } = this.props;
    dispatch({
      type: "projectList/fetchProjectList",
      payload: {
        projectType: currentTabKey,
        ...pageInfo
      }
    });
  };

  // tab切换
  handleTabsChange = key => {
    this.setState(
      {
        currentTabKey: key
      },
      () => {
        this.getList({ page: 1, pageSize: 10 });
      }
    );
  };

  // 渲染编辑按钮
  renderEditBtn = record => {
    return <a onClick={event => this.handleEdit({ record, event })}>编辑</a>;
  };

  // 渲染删除按钮
  renderDelBtn = record => {
    return <a onClick={event => this.handleDelete({ record, event })}>删除</a>;
  };

  render() {
    const { columns, tabData, currentTabKey } = this.state;
    const { spinProps, projectList, pageInfo } = this.props;

    const pageProps = {
      spinProps,
      className: styles.root
    };

    const createBtn = {
      btnText: " 新建项目",
      onCreate: this.handleAddProject
    };

    const tableProps = {
      columns,
      rowKey: "projectId",
      list: projectList,
      onItemClick: this.handleJump,
      pageInfo,
      onPageChange: this.handlePaginationChange
    };
    return (
      <Container breStates version={2}>
        <ListPage {...pageProps}>
          <Tabs
            onChange={this.handleTabsChange}
            type="card"
            activeKey={currentTabKey}
          >
            {tabData.map(({ tabName, tabKey }) => (
              <TabPane tab={tabName} key={tabKey} />
            ))}
          </Tabs>
          <ListCreate {...createBtn} />
          <ListTable {...tableProps} />
        </ListPage>
      </Container>
    );
  }
}

export default List;
